export default "__VITE_ASSET__eaa2b902__"